// index.js (or your main entry file)

// Vendor Components (React 18)
import React from 'react';
import { createRoot } from 'react-dom/client';

// Base Styles
import './styles/foundation/foundation.css';
import 'primeflex/primeflex.css';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';

// Your App Component
import App from './app';

// Grab the container from the DOM
const container = document.getElementById('app');

// Create the root
const root = createRoot(container);

// Render the application
root.render(<App />);
